import React ,{useState} from 'react';
import jMoment from 'moment-jalaali';
import { makeStyles } from '@mui/styles';
import { Tooltip } from '@mui/material';
import Services from '../services/Services';
import { ButtonLoading, Icons } from 'components';
import FileSaver from 'file-saver';

const useStyles = makeStyles((theme) => {
  return {
    button: {
      color: '#303d8f',
      fontWeight: '700',
      whiteSpace: 'nowrap',
      '&.Mui-disabled': {
        '& .MuiButton-startIcon': {
          background: '#f5f5f5',
          '& svg': {
            opacity: '0.2',
          },
        },
      },

      '& .MuiButton-startIcon': {
        background: '#f3f5ff',
        borderRadius: ' 5px',
        padding: '3px',
        '& svg': {
          fontSize: '17px',
          color: 'rgb(43 57 144)',
          opacity: '1',
        },
      },
    },
  };
});

const columns = (classes) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'نام گزارش',
    field: 'report-name',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'تاریخ درخواست گزارش',
    field: 'request-date', //persian-request-date
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) =>
      row['request-date'] ? (
        <span>
          <bdi>
            {parseDataSplit(row['request-date'])[0]} {parseDataSplit(row['request-date'])[1]}
          </bdi>
        </span>
      ) : (
        '-'
      ),
  },
  {
    title: 'بازه خروجی گزارش',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => <DateComponent row={row} />
  },
  {
    title: 'وضعیت آماده سازی',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'status-name',
    render: (rd) => <ShowStatusInColumn rd={rd} classes={classes} />,
  },

  {
    title: 'تاریخ آماده سازی گزارش',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'report-creation-date',
    render: (row) =>
      row['report-creation-date'] ? (
        <span>
          <bdi>
            {parseDataSplit(row['report-creation-date'])[0]}{' '}
            {parseDataSplit(row['report-creation-date'])[1]}
          </bdi>
        </span>
      ) : (
        '-'
      ),
  },

  {
    title: 'فرمت فایل',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'output-type',
     render: (row) =>
      row['output-type']  || row['input-args']['fileFormat'] || '-'
       
    
  },
  {
    title: 'عملیات',
    field: 'operation',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (row) => <SeeDetailBtn row={row} />,
  },
];
const parseData = (data) => {
  return String(data).split(' ')[0];
};
const parseDataSplit = (date) => {
  let t = jMoment(new Date(date))?.format('jYYYY/jMM/jDD HH:mm:ss');
  return t.split(' ');
};

/**
 * ستون وضعیت آماده سازی
 */
const ShowStatusInColumn = ({ rd, classes }) => {
  if (rd?.['status-key'] !== 'FAILED') {
    return <span>{rd['status-name']}</span>;
  } else {
    return (
      <Tooltip
        enterNextDelay="200"
        placement="top"
        title={rd?.['error-message'] || 'خطایی رخ داده است'}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            justifyContent: 'center',
          }}
        >
          خطا
          <span className={classes.inputStatusIcon}>
            <Icons icon='Info' color='#667585' hover='#667585' size='20' />
          </span>
        </div>
      </Tooltip>
    );
  }
};
const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

const DateComponent = ({ row }) => {
  const from = row['report-persian-start-date'] || row['input-args']['startDate'];
  const to = row['report-persian-end-date'] || row['input-args']['endDate'];
  return (
    <>
      {
        from && to
          ? 'از ' +
          parseData(from) +
          ' تا ' +
          parseData(to)
          : '-'
      }
    </>
  )
}

const SeeDetailBtn = ({ row }) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);

  const getData = async (data) => {
    setIsLoading(true);

    const hash = data.substring(data.lastIndexOf('/') + 1);
    try {
      const res = await Services.getFile(hash);
      setIsLoading(false);
      let filename = res.headers['content-disposition'];
     if (filename) {
        filename = filename
          .split(';')
          .find((n) => n.includes('filename='))
          .replace('filename=', '')
          .trim();
        filename = JSON.parse(decodeURI(filename));
        const b = new Blob([res.data]);
        FileSaver.saveAs(b, filename);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getNewLink = async () => {
    setIsLoading(true);
    const podspaceBusinessUrl = process.env?.REACT_APP_BASE_URL_UPLOAD_BUSINESS_INFO_PODSAPCE;
    try {
      const res = await Services.getDownloadableFileUrl(row["request-id"]);
      window.open(`${podspaceBusinessUrl}${res?.result}` , '_blank');
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }
  return (
    <ButtonLoading
      type="buttons"
      variant="text"
      color="primary"
      loading={isLoading}
      name={isLoading ? '' : ' دریافت فایل'}
      className={classes.button}
      startIcon={isLoading ? '' : <Icons icon="Archive" color={row['status-key'] == 'DONE' && row?.downloadable ? "#ccc" : "#2b3990"} size="23" />}
      disabled={row['status-key'] == 'DONE' && row?.downloadable ? false : true}
      onClick={() => {
        if (!isLoading) {
          row?.["use-alternate-download-service"] === true ? getNewLink() : getData(row['download-link']);
        }

      }}
    />
  );
};
export { columns, generateData };
